// Razorpay Configuration Constants
export const RAZORPAY_CONFIG = {
  SANDBOX: {
    KEY_ID: import.meta.env.VITE_RAZORPAY_KEY_ID || "",
  },
  PRODUCTION: {
    KEY_ID: import.meta.env.VITE_RAZORPAY_KEY_ID || "",
  },
}

export const getCurrentConfig = () => {
  const env = import.meta.env.PROD ? "production" : "sandbox"
  return env === "production" ? RAZORPAY_CONFIG.PRODUCTION : RAZORPAY_CONFIG.SANDBOX
}

export const RAZORPAY_ENDPOINTS = {
  CREATE_ORDER: "https://api.razorpay.com/v1/orders",
  VERIFY_PAYMENT: "https://api.razorpay.com/v1/payments",
}

export const PAYMENT_STATUS = {
  PENDING: "pending",
  SUCCESS: "captured",
  FAILED: "failed",
  CANCELLED: "cancelled",
}

export const RAZORPAY_RESPONSE_CODES = {
  SUCCESS: "captured",
  PENDING: "pending",
  FAILED: "failed",
  CANCELLED: "cancelled",
}

export interface RazorpayOrderRequest {
  amount: number // in paise
  currency: string
  receipt: string
  payment_capture: boolean
  notes?: Record<string, string>
}

export interface RazorpayOrderResponse {
  id: string
  entity: string
  amount: number
  amount_paid: number
  amount_due: number
  currency: string
  receipt: string
  offer_id: string | null
  status: string
  attempts: number
  notes: Record<string, string>
  created_at: number
}

export interface RazorpayPaymentResponse {
  razorpay_payment_id: string
  razorpay_order_id: string
  razorpay_signature: string
}

export interface RazorpayPaymentVerification {
  success: boolean
  message: string
  payment_id?: string
  order_id?: string
}
